'use client'

import { TypeOfAnimal, useGetInitialCategoriesQuery } from '@/redux/services/catalogApi'
import Image from 'next/image'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setAnimalType, setCheckboxesCategory, setCheckboxesCategoryType } from '@/redux/features/filterSlice'
import { setCurrentCatalogCategory, setSubCategory } from '@/redux/features/catalogSlice'
import { setAnimalTypesCategory } from '@/redux/features/filterSlice'
import { RootState } from '@/redux/store'
import { useParams, usePathname, useRouter } from 'next/navigation'
import { useAppSelector } from '@/redux/hooks'

import s from '../../scss/CategoryCard.module.scss'
import classNames from 'classnames'

interface Props {
    item: any
    classItem?: string
    sliderTranslate?: (range: number) => void
    type?: any
    linked?: boolean
    lightTheme?: boolean
}

const CatalogCategory: React.FC<Props> = ({ item, classItem, sliderTranslate, linked, type, lightTheme }) => {
    const dispatch = useDispatch()
    const router = useRouter()
    const { animalType, animalTypesCategory } = useSelector((state: RootState) => state.filter)
    const { subCategory } = useAppSelector(state => state.catalogv1)
    const params = useParams()
    const pathname = usePathname()

    const { data: categories } = useGetInitialCategoriesQuery()

    const handleCategory = async (incomingId: number, list) => {
        if (pathname.includes('catalog') && categories) {
            const category = categories.find(c => c.id === incomingId)

            const firstParam = params?.catalog?.[0]
            const paramsCategory = categories.find(c => c.translit === firstParam)

            if (category && item.tags) {
                if (firstParam === category.translit) {
                    const secondParam = params?.catalog?.[1]

                    if (secondParam) {
                        router.push(`/catalog/${secondParam}`)
                    } else router.push('/catalog')
                } else {
                    if (firstParam && !paramsCategory) {
                        router.push(`/catalog/${category.translit}/${firstParam}`)
                    } else router.push(`/catalog/${category.translit}`)
                }
            } else {
                const parentCategory = categories.find(c => c.animal_types_category.find(atc => atc.id === incomingId))
                const foundSubCategory = parentCategory.animal_types_category.find(atc => atc.id === incomingId)

                if (subCategory?.title === foundSubCategory?.title) {
                    dispatch(setSubCategory(null))
                } else dispatch(setSubCategory(foundSubCategory as unknown as TypeOfAnimal))
            }
        } else {
            if (!linked) {
                if (list) {
                    if (!list.length || list.length === 1) {
                        await dispatch(setCurrentCatalogCategory([]))
                        if (animalType.find(id => id === incomingId)) {
                            dispatch(setAnimalType(animalType.filter(id => id !== incomingId)))
                            dispatch(setCheckboxesCategory(null))
                        } else {
                            dispatch(setAnimalType([incomingId]))
                            dispatch(setCheckboxesCategory(incomingId))
                        }
                    } else {
                        await dispatch(setCurrentCatalogCategory([]))
                        dispatch(setAnimalType([incomingId]))
                        dispatch(setCheckboxesCategory(incomingId))
                        dispatch(setCurrentCatalogCategory(list))
                    }
                } else {
                    if (animalTypesCategory.find(id => id === incomingId)) {
                        dispatch(setAnimalTypesCategory(animalTypesCategory.filter(id => id !== incomingId)))
                        dispatch(setCheckboxesCategoryType(null))
                    } else {
                        dispatch(setAnimalTypesCategory([incomingId]))
                        dispatch(setCheckboxesCategoryType(incomingId))
                    }
                }
            } else {
                dispatch(setAnimalType([]))
                dispatch(setCheckboxesCategory(null))
                dispatch(setAnimalTypesCategory([]))
                dispatch(setCheckboxesCategoryType(null))
                router.push(`/catalog?animal_type=${item.animal_type_id}&animal_types_category=${incomingId}`)
            }

            sliderTranslate && sliderTranslate(0)
        }
    }

    if (item) {
        return (
            <li
                draggable
                onClick={() => handleCategory(item.id, item.animal_types_category ? item.animal_types_category : null)}
                className={`categories-slider__card 
            ${lightTheme ? 'lightBgc' : ''}
            ${classItem && classItem} 
            ${animalTypesCategory.find(id => id === item.id) && !linked && 'categories-slider__card_selected'}
            ${
                pathname.includes('catalog')
                    ? params?.catalog?.[0] === item.translit
                        ? 'categories-slider__card_selected'
                        : ''
                    : item?.animal_types_category?.length < 2
                    ? animalType.find(id => id === item.id) && !linked && 'categories-slider__card_selected'
                    : ''
            }
            ${pathname.includes('catalog') && subCategory?.id === item.id ? 'categories-slider__card_selected' : ''}
            `}
            >
                <h3 className={classNames(`categories-slider__title`, lightTheme ? s.lightColorCategoryTitle : '')}>
                    {item.title}
                </h3>
                {classItem === 'labs__features-card' ? (
                    <Image
                        quality={100}
                        src={item.image_url}
                        width={260}
                        height={208}
                        alt='feature-img'
                    />
                ) : (
                    <Image
                        quality={100}
                        width={262}
                        height={262}
                        src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${item.image}`}
                        alt='animal'
                    />
                )}
                <p className='categories-slider__text'>
                    {item.value ? item.value.toLowerCase() : type === 'labs' ? item.bottomLine : null}
                </p>
                {item.description && <p className='labs__features-hover-text'>{item.description}</p>}
            </li>
        )
    } else {
        return null
    }
}

export default CatalogCategory
